module.exports = __webpack_public_path__ + "img/medal2.7c000f19.svg";